import { Action } from '@ngrx/store';
import { type } from '../shared/helpers';

export const ActionTypes = {
    CREATE_CATEGORY: type('CREATE_CATEGORY'),
    CREATE_CATEGORY_SUCCESS: type('CREATE_CATEGORY_SUCCESS'),
    CREATE_CATEGORY_FAIL: type('CREATE_CATEGORY_FAIL'),
    CLEAR_CREATE_CATEGORY_STATE: type('CLEAR_CREATE_CATEGORY_STATE'),

    GET_CATEGORIES_LIST: type('GET_CATEGORIES_LIST'),
    GET_CATEGORIES_LIST_SUCCESS: type('GET_CATEGORIES_LIST_SUCCESS'),
    GET_CATEGORIES_LIST_FAIL: type('GET_CATEGORIES_LIST_FAIL'),

    GET_CATEGORIES_ITEM: type('GET_CATEGORIES_ITEM'),
    GET_CATEGORIES_ITEM_SUCCESS: type('GET_CATEGORIES_ITEM_SUCCESS'),
    GET_CATEGORIES_ITEM_FAIL: type('GET_CATEGORIES_ITEM_FAIL'),
    CLEAR_GET_CATEGORIES_ITEM_STATE: type('CLEAR_GET_CATEGORIES_ITEM_STATE'),

    UPDATE_CATEGORIES_ITEM: type('UPDATE_CATEGORIES_ITEM'),
    UPDATE_CATEGORIES_ITEM_SUCCESS: type('UPDATE_CATEGORIES_ITEM_SUCCESS'),
    UPDATE_CATEGORIES_ITEM_FAIL: type('UPDATE_CATEGORIES_ITEM_FAIL'),
    CLEAR_UPDATE_CATEGORIES_ITEM_STATE: type('CLEAR_UPDATE_CATEGORIES_ITEM_STATE'),

    REMOVE_CATEGORIES_ITEM: type('REMOVE_CATEGORIES_ITEM'),
    REMOVE_CATEGORIES_ITEM_SUCCESS: type('REMOVE_CATEGORIES_ITEM_SUCCESS'),
    REMOVE_CATEGORIES_ITEM_FAIL: type('REMOVE_CATEGORIES_ITEM_FAIL'),
    CLEAR_REMOVE_CATEGORIES_ITEM_STATE: type('CLEAR_REMOVE_CATEGORIES_ITEM_STATE'),

    CREATE_SLIDER_ITEMS: type('CREATE_SLIDER_ITEMS'),
    CREATE_SLIDER_ITEMS_SUCCESS: type('CREATE_SLIDER_ITEMS_SUCCESS'),
    CREATE_SLIDER_ITEMS_FAIL: type('CREATE_SLIDER_ITEMS_FAIL'),
    CLEAR_CREATE_SLIDER_ITEMS_STATE: type('CLEAR_CREATE_SLIDER_ITEMS_STATE'),

    GET_SLIDER_ITEM: type('GET_SLIDER_ITEM'),
    GET_SLIDER_ITEM_SUCCESS: type('GET_SLIDER_ITEM_SUCCESS'),
    GET_SLIDER_ITEM_FAIL: type('GET_SLIDER_ITEM_FAIL'),
    CLEAR_GET_SLIDER_ITEM_STATE: type('CLEAR_GET_SLIDER_ITEM_STATE'),

    GET_SLIDER_LIST: type('GET_SLIDER_LIST'),
    GET_SLIDER_LIST_SUCCESS: type('GET_SLIDER_LIST_SUCCESS'),
    GET_SLIDER_LIST_FAIL: type('GET_SLIDER_LIST_FAIL'),
    CLEAR_GET_SLIDER_LIST_STATE: type('CLEAR_GET_SLIDER_LIST_STATE'),

    REMOVE_SLIDER_ITEM: type('REMOVE_SLIDER_ITEM'),
    REMOVE_SLIDER_ITEM_SUCCESS: type('REMOVE_SLIDER_ITEM_SUCCESS'),
    REMOVE_SLIDER_ITEM_FAIL: type('REMOVE_SLIDER_ITEM_FAIL'),
    CLEAR_REMOVE_SLIDER_ITEM_STATE: type('CLEAR_REMOVE_SLIDER_ITEM_STATE'),

    UPDATE_SLIDER_ITEM: type('UPDATE_SLIDER_ITEM'),
    UPDATE_SLIDER_ITEM_SUCCESS: type('UPDATE_SLIDER_ITEM_SUCCESS'),
    UPDATE_SLIDER_ITEM_FAIL: type('UPDATE_SLIDER_ITEM_FAIL'),
    CLEAR_UPDATE_SLIDER_ITEM_STATE: type('CLEAR_UPDATE_SLIDER_ITEM_STATE'),

    CREATE_PDF_ITEM: type('CREATE_PDF_ITEM'),
    CREATE_PDF_ITEM_SUCCESS: type('CREATE_PDF_ITEM_SUCCESS'),
    CREATE_PDF_ITEM_FAIL: type('CREATE_PDF_ITEM_FAIL'),
    CLEAR_CREATE_PDF_ITEM_STATE: type('CLEAR_CREATE_PDF_ITEM_STATE'),

    DELETE_PDF_ITEM: type('DELETE_PDF_ITEM'),
    DELETE_PDF_ITEM_SUCCESS: type('DELETE_PDF_ITEM_SUCCESS'),
    DELETE_PDF_ITEM_FAIL: type('DELETE_PDF_ITEM_FAIL'),
    CLEAR_DELETE_PDF_ITEM_STATE: type('CLEAR_DELETE_PDF_ITEM_STATE'),

    UPDATE_PDF_ITEM: type('UPDATE_PDF_ITEM'),
    UPDATE_PDF_ITEM_SUCCESS: type('UPDATE_PDF_ITEM_SUCCESS'),
    UPDATE_PDF_ITEM_FAIL: type('UPDATE_PDF_ITEM_FAIL'),
    CLEAR_UPDATE_PDF_ITEM_STATE: type('CLEAR_UPDATE_PDF_ITEM_STATE'),

    GET_PDF_ITEM: type('GET_PDF_ITEM'),
    GET_PDF_ITEM_SUCCESS: type('GET_PDF_ITEM_SUCCESS'),
    GET_PDF_ITEM_FAIL: type('GET_PDF_ITEM_FAIL'),
    CLEAR_GET_PDF_ITEM_STATE: type('CLEAR_GET_PDF_ITEM_STATE'),

    GET_PDF_LIST: type('GET_PDF_LIST'),
    GET_PDF_LIST_SUCCESS: type('GET_PDF_LIST_SUCCESS'),
    GET_PDF_LIST_FAIL: type('GET_PDF_LIST_FAIL'),
    CLEAR_GET_PDF_LIST_STATE: type('CLEAR_GET_PDF_LIST_STATE'),

    CREATE_SLIDER: type('CREATE_SLIDER'),
    CREATE_SLIDER_SUCCESS: type('CREATE_SLIDER_SUCCESS'),
    CREATE_SLIDER_FAIL: type('CREATE_SLIDER_FAIL'),
    CLEAR_CREATE_SLIDER_STATE: type('CLEAR_CREATE_SLIDER_STATE'),

    UPDATE_SLIDER: type('UPDATE_SLIDER'),
    UPDATE_SLIDER_SUCCESS: type('UPDATE_SLIDER_SUCCESS'),
    UPDATE_SLIDER_FAIL: type('UPDATE_SLIDER_FAIL'),
    CLEAR_UPDATE_SLIDER_STATE: type('CLEAR_UPDATE_SLIDER_STATE'),

    REMOVE_SLIDER: type('REMOVE_SLIDER'),
    REMOVE_SLIDER_FAIL: type('REMOVE_SLIDER_FAIL'),
    REMOVE_SLIDER_SUCCESS: type('REMOVE_SLIDER_SUCCESS'),
    CLEAR_REMOVE_SLIDER_STATE: type('CLEAR_REMOVE_SLIDER_STATE'),

    GET_SLIDER: type('GET_SLIDER'),
    GET_SLIDER_SUCCESS: type('GET_SLIDER_SUCCESS'),
    GET_SLIDER_FAIL: type('GET_SLIDER_FAIL'),
    CLEAR_GET_SLIDER_STATE: type('CLEAR_GET_SLIDER_STATE'),

    GET_SLIDERS: type('GET_SLIDERS'),
    GET_SLIDERS_SUCCESS: type('GET_SLIDERS_SUCCESS'),
    GET_SLIDERS_FAIL: type('GET_SLIDERS_FAIL'),
    CLEAR_GET_SLIDERS_STATE: type('CLEAR_GET_SLIDERS_STATE'),
}

export class CreateCategoryAction implements Action {
    type = ActionTypes.CREATE_CATEGORY;
    constructor(public payload: any) { }
}
export class CreateCategoryFailAction implements Action {
    type = ActionTypes.CREATE_CATEGORY_FAIL;
    constructor(public payload: any) { }
}
export class CreateCategorySuccessAction implements Action {
    type = ActionTypes.CREATE_CATEGORY_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearCreateCategoryStateAction implements Action {
    type = ActionTypes.CLEAR_CREATE_CATEGORY_STATE;
    constructor(public payload: any) { }
}

export class GetCategoriesListAction implements Action {
    type = ActionTypes.GET_CATEGORIES_LIST;
    constructor(public payload: any) { }
}
export class GetCategoriesListFailAction implements Action {
    type = ActionTypes.GET_CATEGORIES_LIST_FAIL;
    constructor(public payload: any) { }
}
export class GetCategoriesListSuccesssAction implements Action {
    type = ActionTypes.GET_CATEGORIES_LIST_SUCCESS;
    constructor(public payload: any) { }
}

export class GetCategoriesItemAction implements Action {
    type = ActionTypes.GET_CATEGORIES_ITEM;
    constructor(public payload: any) { }
}
export class GetCategoriesItemFailAction implements Action {
    type = ActionTypes.GET_CATEGORIES_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class GetCategoriesItemSuccessAction implements Action {
    type = ActionTypes.GET_CATEGORIES_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetCategoriesItemStateAction implements Action {
    type = ActionTypes.CLEAR_GET_CATEGORIES_ITEM_STATE;
    constructor(public payload: any) { }
}

export class UpdateCategoriesItemAction implements Action {
    type = ActionTypes.UPDATE_CATEGORIES_ITEM;
    constructor(public payload: any) { }
}
export class UpdateCategoriesItemFailAction implements Action {
    type = ActionTypes.UPDATE_CATEGORIES_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class UpdateCategoriesItemSuccessAction implements Action {
    type = ActionTypes.UPDATE_CATEGORIES_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearUpdateCategoriesItemStateAction implements Action {
    type = ActionTypes.CLEAR_UPDATE_CATEGORIES_ITEM_STATE;
    constructor(public payload: any) { }
}

export class RemoveCategoriesItemAction implements Action {
    type = ActionTypes.REMOVE_CATEGORIES_ITEM;
    constructor(public payload: any) { }
}
export class RemoveCategoriesItemFailAction implements Action {
    type = ActionTypes.REMOVE_CATEGORIES_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class RemoveCategoriesItemSuccessAction implements Action {
    type = ActionTypes.REMOVE_CATEGORIES_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearRemoveCategoriesItemStateAction implements Action {
    type = ActionTypes.CLEAR_REMOVE_CATEGORIES_ITEM_STATE;
    constructor(public payload: any) { }
}

export class CreateSliderItemAction implements Action {
    type = ActionTypes.CREATE_SLIDER_ITEMS;
    constructor(public payload: any) { }
}
export class CreateSliderItemSuccessAction implements Action {
    type = ActionTypes.CREATE_SLIDER_ITEMS_SUCCESS;
    constructor(public payload: any) { }
}
export class CreateSliderItemFailAction implements Action {
    type = ActionTypes.CREATE_SLIDER_ITEMS_FAIL;
    constructor(public payload: any) { }
}
export class ClearCreateSliderItemAStatection implements Action {
    type = ActionTypes.CLEAR_CREATE_SLIDER_ITEMS_STATE;
    constructor(public payload: any) { }
}

export class GetSliderItemAction implements Action {
    type = ActionTypes.GET_SLIDER_ITEM;
    constructor(public payload: any) { }
}
export class GetSliderItemFailAction implements Action {
    type = ActionTypes.GET_SLIDER_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class GetSliderItemSuccessAction implements Action {
    type = ActionTypes.GET_SLIDER_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetSliderItemStateAction implements Action {
    type = ActionTypes.CLEAR_GET_SLIDER_ITEM_STATE;
    constructor(public payload: any) { }
}

export class GetSliderListAction implements Action {
    type = ActionTypes.GET_SLIDER_LIST;
    constructor(public payload: any) { }
}
export class GetSliderListFailAction implements Action {
    type = ActionTypes.GET_SLIDER_LIST_FAIL;
    constructor(public payload: any) { }
}
export class GetSliderListSuccessAction implements Action {
    type = ActionTypes.GET_SLIDER_LIST_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetSliderListStateAction implements Action {
    type = ActionTypes.CLEAR_GET_SLIDER_LIST_STATE;
    constructor(public payload: any) { }
}

export class RemoveSliderItemAction implements Action {
    type = ActionTypes.REMOVE_SLIDER_ITEM;
    constructor(public payload: any) { }
}
export class RemoveSliderItemFailAction implements Action {
    type = ActionTypes.REMOVE_SLIDER_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class RemoveSliderItemSuccessAction implements Action {
    type = ActionTypes.REMOVE_SLIDER_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearRemoveSliderItemStateAction implements Action {
    type = ActionTypes.CLEAR_REMOVE_SLIDER_ITEM_STATE;
    constructor(public payload: any) { }
}

export class UpdateSliderItemAction implements Action {
    type = ActionTypes.UPDATE_SLIDER_ITEM;
    constructor(public payload: any) { }
}
export class UpdateSliderItemFailAction implements Action {
    type = ActionTypes.UPDATE_SLIDER_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class UpdateSliderItemSuccessAction implements Action {
    type = ActionTypes.UPDATE_SLIDER_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearUpdateSliderItemStateAction implements Action {
    type = ActionTypes.CLEAR_UPDATE_SLIDER_ITEM_STATE;
    constructor(public payload: any) { }
}

export class CreatePdfItemAction implements Action {
    type = ActionTypes.CREATE_PDF_ITEM;
    constructor(public payload: any) { }
}
export class CreatePdfItemSuccessAction implements Action {
    type = ActionTypes.CREATE_PDF_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class CreatePdfItemFailAction implements Action {
    type = ActionTypes.CREATE_PDF_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class ClearCreatePdfItemStateAction implements Action {
    type = ActionTypes.CLEAR_CREATE_PDF_ITEM_STATE;
    constructor(public payload: any) { }
}

export class DeletePdfItemAction implements Action {
    type = ActionTypes.DELETE_PDF_ITEM;
    constructor(public payload: any) { }
}
export class DeletePdfItemFailAction implements Action {
    type = ActionTypes.DELETE_PDF_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class DeletePdfItemSuccessAction implements Action {
    type = ActionTypes.DELETE_PDF_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearDeletePdfItemStateAction implements Action {
    type = ActionTypes.CLEAR_DELETE_PDF_ITEM_STATE;
    constructor(public payload: any) { }
}

export class UpdatePdfItemAction implements Action {
    type = ActionTypes.UPDATE_PDF_ITEM;
    constructor(public payload: any) { }
}
export class UpdatePdfItemFailAction implements Action {
    type = ActionTypes.UPDATE_PDF_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class UpdatePdfItemSuccessAction implements Action {
    type = ActionTypes.UPDATE_PDF_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearUpdatePdfItemStateAction implements Action {
    type = ActionTypes.CLEAR_UPDATE_PDF_ITEM_STATE;
    constructor(public payload: any) { }
}

export class GetPdfItemAction implements Action {
    type = ActionTypes.GET_PDF_ITEM;
    constructor(public payload: any) { }
}
export class GetPdfItemFailAction implements Action {
    type = ActionTypes.GET_PDF_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class GetPdfItemSuccessAction implements Action {
    type = ActionTypes.GET_PDF_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetPdfItemStateAction implements Action {
    type = ActionTypes.CLEAR_GET_PDF_ITEM_STATE;
    constructor(public payload: any) { }
}

export class GetPdfListAction implements Action {
    type = ActionTypes.GET_PDF_LIST;
    constructor(public payload: any) { }
}
export class GetPdfListFailAction implements Action {
    type = ActionTypes.GET_PDF_LIST_FAIL;
    constructor(public payload: any) { }
}
export class GetPdfListSuccessAction implements Action {
    type = ActionTypes.GET_PDF_LIST_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetPdfListStateAction implements Action {
    type = ActionTypes.CLEAR_GET_PDF_LIST_STATE;
    constructor(public payload: any) { }
}

export class CreateSliderAction implements Action {
    type: string = ActionTypes.CREATE_SLIDER;
    constructor(public payload: any) { }
}
export class CreateSliderFailAction implements Action {
    type: string = ActionTypes.CREATE_SLIDER_FAIL;
    constructor(public payload: any) { }
}
export class CreateSliderSuccessAction implements Action {
    type: string = ActionTypes.CREATE_SLIDER_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearCreateSliderStateAction implements Action {
    type: string = ActionTypes.CLEAR_CREATE_SLIDER_STATE;
    constructor(public payload: any) { }
}

export class UpdateSliderAction implements Action {
    type: string = ActionTypes.UPDATE_SLIDER;
    constructor(public payload: any) { }
}
export class UpdateSliderFailAction implements Action {
    type: string = ActionTypes.UPDATE_SLIDER_FAIL;
    constructor(public payload: any) { }
}
export class UpdateSliderSuccessAction implements Action {
    type: string = ActionTypes.UPDATE_SLIDER_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearUpdateSliderStateAction implements Action {
    type: string = ActionTypes.CLEAR_UPDATE_SLIDER_STATE;
    constructor(public payload: any) { }
}

export class RemoveSliderAction implements Action {
    type: string = ActionTypes.REMOVE_SLIDER;
    constructor(public payload: any) { }
}
export class RemoveSliderSuccessAction implements Action {
    type: string = ActionTypes.REMOVE_SLIDER_SUCCESS;
    constructor(public payload: any) { }
}
export class RemoveSliderFailAction implements Action {
    type: string = ActionTypes.REMOVE_SLIDER_FAIL;
    constructor(public payload: any) { }
}
export class ClearRemoveSliderStateAction implements Action {
    type: string = ActionTypes.CLEAR_REMOVE_SLIDER_STATE;
    constructor(public payload: any) { }
}

export class GetSliderAction implements Action {
    type: string = ActionTypes.GET_SLIDER;
    constructor(public payload: any) { }
}
export class GetSliderSuccessAction implements Action {
    type: string = ActionTypes.GET_SLIDER_SUCCESS;
    constructor(public payload: any) { }
}
export class GetSliderFailAction implements Action {
    type: string = ActionTypes.GET_SLIDER_FAIL;
    constructor(public payload: any) { }
}
export class ClearGetSliderStateAction implements Action {
    type: string = ActionTypes.CLEAR_GET_SLIDER_STATE;
    constructor(public payload: any) { }
}

export class GetSlidersAction implements Action {
    type: string = ActionTypes.GET_SLIDERS;
    constructor(public payload: any) { }
}
export class GetSlidersSuccessAction implements Action {
    type: string = ActionTypes.GET_SLIDERS_SUCCESS;
    constructor(public payload: any) { }
}
export class GetSlidersFailAction implements Action {
    type: string = ActionTypes.GET_SLIDERS_FAIL;
    constructor(public payload: any) { }
}
export class ClearGetSlidersStateAction implements Action {
    type: string = ActionTypes.CLEAR_GET_SLIDERS_STATE;
    constructor(public payload: any) { }
}

export type Actions =
    | CreateCategoryAction
    | CreateCategoryFailAction
    | CreateCategorySuccessAction
    | ClearCreateCategoryStateAction
    | GetCategoriesListAction
    | GetCategoriesListFailAction
    | GetCategoriesListSuccesssAction
    | GetCategoriesItemAction
    | GetCategoriesItemFailAction
    | GetCategoriesItemSuccessAction
    | ClearGetCategoriesItemStateAction
    | UpdateCategoriesItemAction
    | UpdateCategoriesItemFailAction
    | UpdateCategoriesItemSuccessAction
    | ClearUpdateCategoriesItemStateAction
    | RemoveCategoriesItemAction
    | RemoveCategoriesItemFailAction
    | RemoveCategoriesItemSuccessAction
    | ClearRemoveCategoriesItemStateAction
    | CreateSliderItemAction
    | CreateSliderItemFailAction
    | CreateSliderItemSuccessAction
    | ClearCreateSliderItemAStatection
    | GetSliderItemAction
    | GetSliderItemFailAction
    | GetSliderItemSuccessAction
    | ClearGetSliderItemStateAction
    | GetSliderListAction
    | GetSliderListFailAction
    | GetSliderListSuccessAction
    | ClearGetSliderListStateAction
    | RemoveSliderItemAction
    | RemoveSliderItemFailAction
    | RemoveSliderItemSuccessAction
    | ClearRemoveSliderItemStateAction
    | UpdateSliderItemAction
    | UpdateSliderItemFailAction
    | UpdateSliderItemSuccessAction
    | ClearUpdateSliderItemStateAction
    | CreatePdfItemAction
    | CreatePdfItemFailAction
    | CreatePdfItemSuccessAction
    | ClearCreatePdfItemStateAction
    | DeletePdfItemAction
    | DeletePdfItemFailAction
    | DeletePdfItemSuccessAction
    | ClearDeletePdfItemStateAction
    | UpdatePdfItemAction
    | UpdatePdfItemFailAction
    | UpdatePdfItemSuccessAction
    | ClearUpdatePdfItemStateAction
    | GetPdfItemAction
    | GetPdfItemFailAction
    | GetPdfItemSuccessAction
    | ClearGetPdfItemStateAction
    | GetPdfListAction
    | GetPdfListFailAction
    | GetPdfListSuccessAction
    | ClearGetPdfListStateAction
    | CreateSliderAction
    | CreateSliderSuccessAction
    | CreateSliderFailAction
    | ClearCreateSliderStateAction
    | UpdateSliderAction
    | UpdateSliderFailAction
    | UpdateSliderSuccessAction
    | ClearUpdateSliderStateAction
    | RemoveSliderAction
    | RemoveSliderFailAction
    | RemoveSliderSuccessAction
    | ClearRemoveSliderStateAction
    | GetSliderAction
    | GetSliderSuccessAction
    | GetSliderFailAction
    | ClearGetSliderStateAction
    | GetSlidersAction
    | GetSlidersSuccessAction
    | GetSlidersFailAction
    | ClearGetSlidersStateAction